import React, { useEffect, useRef } from "react";
import ImgSupport from "../../assets/img-support.svg";
import { FaUserPlus } from "react-icons/fa";
import { MdOutlineArrowOutward } from "react-icons/md";
import { Accordion } from "flowbite-react";
import { Link, useLocation } from "react-router-dom";
import BankDetails from "../../components/BankDetails";
import { ChatSupport } from "../../components/ChatSupport";

function Support() {
  const location = useLocation();
  const bankDetailsRef = useRef(null);

  useEffect(() => {
    if (location.pathname === "/support/bankdetails") {
      const offsetTop = bankDetailsRef.current?.offsetTop || 0;
      window.scrollTo({
        top: offsetTop - 60, // Scroll to 30px above the section
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <div className="flex flex-col items-center mt-16 w-full px-4 md:px-0 pb-36">
      <img src={ImgSupport} alt="" className="size-[400px] drop-shadow-lg" />
      <div className="w-full max-w-screen-lg border bg-myPurple py-16 -translate-y-20 rounded-xl ">
        <h1 className="font-bold text-4xl md:text-6xl text-center text-myWhite ">
          Need any support?
        </h1>
      </div>

      <div>
        <ChatSupport />
      </div>
      
      <div ref={bankDetailsRef}>
        <BankDetails />
      </div>

      <div className="px-4 flex flex-col items-center">
        <h2 className="text-2xl font-semibold py-8 ">
          A/L Guidance වෙබ් අඩවිය සඳහා Register වන ආකාරය.
        </h2>
        <div className="w-full lg:w-[1024px] aspect-video">
          <iframe
            className="w-full h-full rounded-lg shadow-lg"
            src="https://www.youtube.com/embed/aRxx0srg9ns?si=Zd99BozwJBLJEVLL"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />

      <div className="px-4 flex flex-col items-center">
        <h2 className="text-2xl font-semibold py-8 ">
          BANK SLIPS හරහා පාඨමාලාවක් මිලදී ගන්නා ආකාරය.
        </h2>
        <div className="w-full lg:w-[1024px] aspect-video">
          <iframe
            className="w-full h-full rounded-lg shadow-lg"
            src="https://www.youtube.com/embed/GaKw7fkpZ9k?si=etGUsp5ocUY8vrVC"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />

      {/* <div className="px-4 flex flex-col items-center">
        <h2 className="text-2xl font-semibold py-8 ">
          ONLINE ක්‍රමවේදය හරහා පාඨමාලාවක් මිලදී ගන්නා ආකාරය.
        </h2>
        <iframe
          className="w-full lg:w-[900px] h-64 lg:h-[500px]"
          width="auto"
          height="auto"
          src="https://www.youtube.com/embed/EPvY63lQHjU?si=SaiwUVRe_dc6r6lr"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div> */}
      {/* /Support Cards */}

      {/* FAQ----------------------------- */}
      <div className="bg-myBlue bg-opacity-10 w-full mt-28 flex items-center justify-center">
        <h2 className="font-bold  text-2xl py-2 text-myBlack">FAQs</h2>
      </div>
      {/* -----------------------FAQ------------------- */}
      <Accordion className="w-full px-8 md:px-20 mt-10 mb-28 border-none">
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none">
            පාඨමාලාවන් සඳහා මුදල් ගෙවිය හැකි ආකාර?
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2  text-gray-500">
              පාඨමාලාවන් සඳහා ආකාර දෙකකට මුදල් ගෙවීම සිදු කල හැක.
              <br />
              <br />
              <ul>
                <li>
                  - <strong> බැංකු රිසිට්පත් මගින්</strong>
                </li>
                <ul>
                  <li>
                    පාඨමාලාවට අදාල මුදල අපගේ බැංකු ගිණුමට බැර කල රිසිට්පත පහත
                    video වේ දැක්වෙන ආකාරයට upload කිරීමෙන් අදාල පාඨමාලාව මිලදී
                    ගත හැක. (‍රිසිට්පත upload කිරීමෙන් පැය 24ක් ඇතුලත අදාල
                    පාඨමාලාව සක්‍රීය වනු ඇත. )
                    <br />
                    <br />
                    <a href="#">Click here to see the video</a>
                  </li>
                </ul>
                <br />
              </ul>
            </p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none">
            තාක්ෂණික සහය සඳහා පිවිසෙන්න
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2 text-gray-500 dark:text-gray-400">
              තාක්ෂණික සහය සඳහා support පිටුවට පිවිසෙන්න
              <br />
              <br />
              <Link to={"/support"}>click here</Link>
            </p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none rounded-b-lg">
            What should I do if I forget my password?
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2 text-gray-500 dark:text-gray-400">
              If you forget your password, click the "Forgot Password?" link on
              the login page. You will receive an email with instructions to
              reset your password.
            </p>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </div>
  );
}

export default Support;
